<!-- Start::page-header -->
<div class="my-4 page-header-breadcrumb flex items-center justify-between flex-wrap gap-2 single-page-header">
    <div>
        <!-- <h1 class="page-title font-medium text-[1.125rem] mb-2">{{routerEvents[routerEvents.length - 1].replace('-', ' ') | titlecase}}</h1> -->
        <ol class="breadcrumb mb-0 flex flex-wrap">
            <li [ngClass]="'active'" class="breadcrumb-item active">
                <a href="javascript:void(0);">
                    {{routerEvents[0]?.replace('-', ' ') | decodeUri | titlecase}}</a>
            </li>
        </ol>
    </div>
</div>
<!-- End::page-header -->